import React, { Component } from 'react';
import './App.css';
import sandwich from './images/sandwich_white.svg'
import odo_logo_purple from './images/odo_logo_purple.svg'


class Header extends Component {
	
    handleNavClick(page){
		this.props.trayCB(page)
    }

  render() {

    return (
    	<div className="oddHeader">
    		<div className="oddBrand" onClick={() => this.handleNavClick("home")}>
                  <img onClick={this.handleSandwichClick} height="23px" alt="Oddmachine Logo" width="23px" className="sandwich" src={sandwich} /> 
                  <span className="oddLogo"> <img className="odoLogo" src={odo_logo_purple} alt="Oddmachine Design Office" height="63" width="149" /></span>
                  <div className="oddHead2">user experience, brand & identity, product management & innovation</div>
              </div>
              <div className="oddNav"><div className="oddNavLink" onClick={() => this.handleNavClick("engage")}>About</div> 
			</div>
			</div>
    )
  }
}

export default Header;


// WEBPACK FOOTER //
// ./src/Header.js